import { Container } from './styles'
import { Link } from 'gatsby'
import { ReactComponent as LogoDesktop } from '../../../assets/logoTAGFull.svg'
import { ReactComponent as LogoMobile } from '../../../assets/logoTAG.svg'
import React from 'react'

export function TAGLogoLink() {
  return (
    <Link to="/">
      <Container>
        <LogoDesktop
          aria-label="Tag Logo"
          className="logo__desktop"
          role="img"
        />
        <LogoMobile
          aria-label="Tag Logo"
          className="logo__mobile"
          role="img"
        />
      </Container>
    </Link>
  )
}
